module Meevo.Components.GlobalNav {
    "use strict";

    export interface IEnhancedLocationItem {
        locationId: number;
        id: number;
        storeName: string;
    }

    export class EnhancedLocationDropdownController {
        static $inject = [
            "meevo.components.locationPicker.LocationPickerService",
            "meevo.components.common.DataService",
            "$timeout",
            "currentLocationName"
        ];

        activeLocation: IEnhancedLocationItem | null = null;
        filteredLocations: IEnhancedLocationItem[] = [];
        searchText: string = "";
        isLoading: boolean = true;
        noResults: boolean = false;

        private searchDebounce: ng.IPromise<any> | null = null;

        constructor(
            private locationPickerService: Meevo.Components.LocationPicker.ILocationPickerService,
            private dataService: any,
            private $timeout: ng.ITimeoutService,
            private currentLocationName: string
        ) {
            this.loadLocations("");
        }

        onSearch(): void {
            if (this.searchDebounce) {
                this.$timeout.cancel(this.searchDebounce);
            }
            this.searchDebounce = this.$timeout(() => {
                this.loadLocations(this.searchText);
            }, 300);
        }

        select(location: IEnhancedLocationItem): void {
            const locationId = location.locationId || location.id;
            this.locationPickerService.switchLocation(locationId);
        }

        private loadLocations(search: string): void {
            this.isLoading = true;
            this.noResults = false;

            const request: any = {
                pageNumber: 0,
                itemsPerPage: 200,
                criteria: {
                    filterBySessionUser: true,
                    locationStatus: [
                        Meevo.Model.LocationStatusEnum.Active,
                        Meevo.Model.LocationStatusEnum.ClosingPlanned,
                        Meevo.Model.LocationStatusEnum.TemporarilyClosed
                    ],
                    subscriptionStatus: [Meevo.Model.SubscriptionStatusEnum.Active],
                    filter: "%" + (search || "") + "%"
                },
                includeActive: true,
                includeDeleted: false,
                includeInactive: false
            };

            this.dataService.getListPaged("changelocation", request).then((response: any) => {
                const items: IEnhancedLocationItem[] = response || [];

                const currentName = (this.currentLocationName || "").trim().toLowerCase();
                const active = items.find(loc =>
                    loc.storeName && loc.storeName.trim().toLowerCase() === currentName
                );
                const others = items
                    .filter(loc => loc !== active)
                    .sort((a, b) => (a.storeName || "").localeCompare(b.storeName || ""));

                this.activeLocation = active || null;
                this.filteredLocations = others;
                this.noResults = !active && others.length === 0;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
                this.noResults = true;
            });
        }
    }

    angular.module("meevo.components.globalNav")
        .controller("Meevo.Components.GlobalNav.EnhancedLocationDropdownController",
            EnhancedLocationDropdownController);
}
